import React from 'react';
import { Container } from 'react-bootstrap';
import './ResumeSection.css';

function ResumeSection () {
    return (
        <div>

            <Container>

            <div class="row">
                <div class="col">
                    <img className='resume__img' src='images/et10.png' alt='quicklearn' />
                </div>
                <div class="col" style={{paddingTop:85}}>
                    <p className='main_heading'>Craft Your Future </p> 
                        <p className='small_heading'>"Build Your Professional Resume with Quicklearn Resume Builder!"  
                        <br/>
                        <span className='desc'>An interactive website tool or piece of software that provides many resume templates and enables users to quickly and easily construct a resume.</span> <br/>
                       <a href='https://resume-builder-55.netlify.app/'> <button className='resume__button'>Create Resume</button> </a>
                     </p>
                </div>
            </div>
            </Container>
            <hr/>
        </div>
    );
}

export default ResumeSection;
